// components/Celebration/CelebrationScreen.jsx
import React, { useEffect, useState } from "react";
import ConfettiLayer from "./ConfettiLayer";
import CTAButtons from "./CTAButtons";
import { celebrationThemes } from "./celebrationThemes";

const CelebrationScreen = ({
  title,
  subtitle,
  theme = "default",
  children,
  onNext,
  onBack,
  hideBack = false,
  hideGlobalCTA = false,   // <— new prop
}) => {
  const [showConfetti, setShowConfetti] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setShowConfetti(false), 4000);
    return () => clearTimeout(t);
  }, []);

  const currentTheme = celebrationThemes[theme] || celebrationThemes.default;

  return (
    <div
      className="
        relative w-full max-h-screen
        flex flex-col items-center
        bg-white px-4 scrollbar-hide
      "
    >
      {showConfetti && <ConfettiLayer colors={currentTheme.confettiColors} />}

      <h1 className="text-xl md:text-2xl lg:text-[32px] font-medium font-gotham leading-9 text-[#323232] max-w-3xl text-center">
        {title}
      </h1>

      {subtitle && (
        <p className="mt-1 text-sm md:text-base text-gray-600 text-center">
          {subtitle}
        </p>
      )}

      <div className="mt-8 w-full max-w-5xl flex-1 min-h-0 flex justify-center overflow-y-auto scrollbar-hide">
        {children}
      </div>

      {!hideGlobalCTA && (
        <div className="mt-10 mb-10">
          <CTAButtons onNext={onNext} onBack={onBack} hideBack={hideBack} />
        </div>
      )}
    </div>
  );
};

export default CelebrationScreen;